import { render, staticRenderFns } from "./BLabel.vue?vue&type=template&id=078ba19e&scoped=true"
import script from "./BLabel.vue?vue&type=script&lang=js"
export * from "./BLabel.vue?vue&type=script&lang=js"
import style0 from "./BLabel.vue?vue&type=style&index=0&id=078ba19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078ba19e",
  null
  
)

export default component.exports